import * as types from '../types/payment';
import * as api from '../constants/';
import axios from 'axios';

function setPayment(data) {
  return {
    type: types.PAYMENT_ASSERT,
    data: data,
  };
}

export function assertPayment(lng, type, id, restaurantID) {
  return dispatch => {
    const url = api.api_url + `/${lng}` + api.PAYMENT_ASSERT + `${type}/${id}/${restaurantID}/`;
    return axios.get(url).then((response) => {
      dispatch(setPayment(response.data));
      return Promise.resolve(response);
    });
  };
}


// WEBPACK FOOTER //
// ./src/actions/paymentActions.js